module.exports = __webpack_public_path__ + "img/2f_r_koichiro@2x.a7128c6b.png";